module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-it-a8a03c5c39afb2c76a6381b14d4f1b5f.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/apple-app-store-it.svg
// module id = LruI
// module chunks = 20 22